import axios from "axios";
import { axiosRequestInterceptor } from "./axios-interceptors/request";
import { axiosResponseInterceptor } from "./axios-interceptors/response";

import urls from "./urls";

const /**
   * base url from admin api
   * @type {string}
   */
  baseUrlAdmin = urls.baseUrlAdmin,
  /**
   * base url from oms api
   * @type {string}
   */
  baseUrlOMS = urls.baseUrlOMS,
  /**
   * base url from cc api
   * @type {string}
   */
  baseUrlCC = urls.baseUrlCC,
  /**
   * base url from reward api
   * @type {string}
   */
  baseUrlReward = urls.baseUrlReward,
  /**
   * base url from learning api
   * @type {string}
   */
  baseUrlLearning = urls.baseUrlLearning,
  /**
   * base url from missions api
   * @type {string}
   */
  baseUrlMissions = urls.baseUrlMissions,
  /**
   * base url from xmailing api
   * @type {string}
   */
  baseUrlXmailing = urls.baseUrlXmailing,
  /**
   * base url from default
   * @type {string}
   */
  baseURL = urls.baseURL,
  /**
   * base url from front
   */
  baseFrontUrl = urls.baseFrontUrl;

/**
 * create api resource
 *
 * @type {AxiosInstance}
 */
const api = axios.create({
  baseURL: baseURL,
});

axiosRequestInterceptor(api)
axiosResponseInterceptor(api)

export {
  baseURL,
  baseUrlAdmin,
  baseUrlOMS,
  baseUrlCC,
  baseFrontUrl,
  baseUrlXmailing,
  baseUrlReward,
  baseUrlLearning,
  baseUrlMissions,
};

export default api;
